import { createReducer, on } from "@ngrx/store";
import { ProjectScheduleLineItem } from "src/app/models/dbmodels";
import { loadPerformanceLineItemSuccess, loadPerformanceLineItemFailure, loadPricingLineItemSuccess, loadPricingLineItemFailure, updateItemConfiguration, updateItemConfigurationHeader, updateLineItemId, clearPerformanceLineItem, clearItemConfigurationHeader } from "./item-configuration.actions";
import { ItemConfigurationHeaderViewModel } from "src/app/models/config-view-models";
import { ProjectScheduleLineItemPricing } from "src/app/models/pricing-view-models";

export const initialItemConfigurationHeaderState: ItemConfigurationHeaderViewModel = {
  ProductTypeId: null,
	ProductTypeCategoryId: null,
	ProductModelClassId: null,
	ProductModelId: null,
  ItemQty: 1,
  ItemTag: 'UNIT-'
} as ItemConfigurationHeaderViewModel;

export const itemConfigurationHeaderFeatureKey = 'itemConfigurationHeaderState';
export const scheduleLineItemFeatureKey = 'scheduleLineItemState';
export const itemConfigurationPerformanceFeatureKey = 'itemConfigurationPerformanceState';
export const itemConfigurationPricingFeatureKey = 'itemConfigurationPricingState';

export interface ItemConfigurationHeaderState {
  itemConfigurationHeader: ItemConfigurationHeaderViewModel;
}
export interface LineItemState {
  LineItemId?: number;
}
export interface initialLineItemState {
  LineItemId?: number;
}
export const initialLineItemState: LineItemState = {
  LineItemId: null
}
export interface ProjectScheduleLineItemState {
  projectScheduleLineItem: ProjectScheduleLineItem;
}
export interface ProjectScheduleLineItemPricingState {
  projectScheduleLineItemPricing: ProjectScheduleLineItemPricing;
}
export const initialProjectScheduleLineItemState: ProjectScheduleLineItemState = {
  projectScheduleLineItem: null
}
export const initialProjectScheduleLineItemPricingState: ProjectScheduleLineItemPricingState = {
  projectScheduleLineItemPricing: null
}

export const itemConfigurationHeaderReducer = createReducer(
    initialItemConfigurationHeaderState,
    on(updateItemConfigurationHeader, (state, { itemConfigHeader }) => {
      //console.log('itemConfigurationHeaderReducer - 1 - updateItemConfigurationHeader', itemConfigHeader);
      let rtn = {...state,
          ProductTypeId: itemConfigHeader.ProductTypeId,
          ProductTypeCategoryId: itemConfigHeader.ProductTypeCategoryId,
          ProductModelClassId: itemConfigHeader.ProductModelClassId,
          ProductModelId: itemConfigHeader.ProductModelId,
          ProductType: itemConfigHeader.ProductType,
          ProductTypeCategory: itemConfigHeader.ProductTypeCategory,
          ProductModelClass: itemConfigHeader.ProductModelClass, 
          ProductModel: itemConfigHeader.ProductModel,
          ItemTag: itemConfigHeader.ItemTag,
          ItemQty: itemConfigHeader.ItemQty
      };
      //console.log('itemConfigurationHeaderReducer - 2 - updateItemConfigurationHeader', rtn);
      return rtn;
    }),
    on(clearItemConfigurationHeader, (state) => {
      //console.log('itemConfigurationHeaderReducer - clearItemConfigurationHeaderState', initialItemConfigurationHeaderState);
      return initialItemConfigurationHeaderState;
    })
);
export const scheduleLineItemReducer = createReducer(
  initialLineItemState,
  on(updateLineItemId, (state, { lineItemId }) => {
    let id = lineItemId > 0 ? lineItemId : null;
    let rtn = {...state, LineItemId: id};
    return rtn;
  }),
);
export const itemConfigurationPerformanceReducer = createReducer(
  initialProjectScheduleLineItemState,
  on(loadPerformanceLineItemSuccess, (state, { projectScheduleLineItem }) => {
    //console.log('scheduleLineItemReducer - loadPerformanceLineItemSuccess', projectScheduleLineItem);
    let rtn = {...state, projectScheduleLineItem: projectScheduleLineItem};
    return rtn;
  }),
  on(loadPerformanceLineItemFailure, (state, { error }) => {
    console.error(error);
    return state;
  }),
  on(clearPerformanceLineItem, (state) => {
    //console.log('scheduleLineItemReducer - clearPerformanceLineItem');
    return initialProjectScheduleLineItemState;
  })
);
export const itemConfigurationPricingReducer = createReducer(
  initialProjectScheduleLineItemPricingState,
  on(loadPricingLineItemSuccess, (state, { projectScheduleLineItemPricing }) => {
    let rtn = {...state, projectScheduleLineItemPricing: projectScheduleLineItemPricing};
    return rtn;
  }),
  on(loadPricingLineItemFailure, (state, { error }) => {
    console.error(error);
    return state;
  }),
);
